import { errorTypes } from '../validators/error-types';
import { console } from '../utility/console';

interface ErrorOptions {
  custom?: string; // Custom message
  maxStringLength?: number; // Maximum length value of string
  subject?: string; // Value being evaluated
}

export const outputErrorMessage = (errorCode: string | null, name: string, options: ErrorOptions = {}): void => {
  const header = `Validation failed for User Profile "${name}"`;

  switch (errorCode) {
    case errorTypes.UNDEFINED:
      console.error(`${header}: The ${options.subject} cannot be undefined.`);
      break;
    case errorTypes.NULL:
      console.error(`${header}: The ${options.subject} cannot be null.`);
      break;

    // String
    case errorTypes.EMPTY_STRING:
      console.error(`${header}: The ${options.subject} cannot be empty.`);
      break;
    case errorTypes.EXCEED_LENGTH:
      console.error(`${header}: The ${options.subject} must be ${options.maxStringLength} characters or less.`);
      break;
    case errorTypes.INVALID_STRING:
      console.error(`${header}: The ${options.subject} must be a valid string value.`);
      break;
    case errorTypes.NOT_STRING:
      console.error(`${header}: The ${options.subject} must be a string.`);
      break;
    case errorTypes.NO_STANDARD_PREFIX:
      console.error(`${header}: The ${options.subject} cannot have the prefix "___repro___".`);
      break;

    // Number
    case errorTypes.INVALID_DOUBLE_NUMBER:
      console.error(`${header}: The ${options.subject} must be a valid double value.`);
      break;
    case errorTypes.NOT_DOUBLE_NUMBER:
      console.error(`${header}: The ${options.subject} must be a double.`);
      break;
    case errorTypes.INVALID_INT_NUMBER:
      console.error(`${header}: The ${options.subject} must be a valid integer value.`);
      break;
    case errorTypes.NOT_INT_NUMBER:
      console.error(`${header}: The ${options.subject} must be a integer.`);
      break;

    // Date
    case errorTypes.NOT_DATE:
      console.error(`${header}: The ${options.subject} must be a date.`);
      break;
    case errorTypes.INVALID_DATE:
      console.error(`${header}: The ${options.subject} is a invalid date.`);
      break;

    case errorTypes.CUSTOM:
      console.error(`${header}: ${options.custom}`);
      break;

    default:
      console.error(header);
  }
};
